import { getBoxCode } from '@/api/user'
import { getStorage } from '../utils'

export const generJumpLink = async (boxAppKey) => {
  const appkey = getStorage("appkey");
  const user_id = getStorage("user_id");
  const phone = getStorage("username");
  const device_info = getStorage('device_info');
  const pkgName = device_info.bundleid;
  const access_token = getStorage("access_token");
  const r = await getBoxCode({
    access_token,
    user_id,
    appkey
  })
  const authCode = r.content.authorize_code;
  return {
    boxGiftUrl: `wxbt://com.hzwx.bt.box/app/moreGift?appKey=${boxAppKey || appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`,
    wxBoxGiftUrl: `wxsy://com.hzwx.wx.box/app/moreGift?appKey=${boxAppKey || appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`,
    boxMainUrl: `wxbt://com.hzwx.bt.box/app/main?appKey=${boxAppKey || appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`,
    wxBoxMainUrl: `wxsy://com.hzwx.wx.box/app/main?appKey=${boxAppKey || appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`,
    boxNewGameUrl: `wxbt://com.hzwx.bt.box/app/gameDetail?appKey=${boxAppKey || appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`,
    wxBoxNewGameUrl: `wxsy://com.hzwx.wx.box/app/gameDetail?appKey=${boxAppKey || appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`,
    wxBoxForumUrl: `wxsy://com.hzwx.wx.box/app/main?routePath=bbs&appKey=${boxAppKey || appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`,
  }
}

export const generActLink = async (url) => {
  const appkey = getStorage("appkey");
  const user_id = getStorage("user_id");
  const phone = getStorage("username");
  const device_info = getStorage('device_info');
  const pkgName = device_info.bundleid;
  const access_token = getStorage("access_token");
  const r = await getBoxCode({
    access_token,
    user_id,
    appkey
  })
  const authCode = r.content.authorize_code;
  if (url.indexOf("?") != -1) {
    return `${url}&appKey=${appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`
  } else {
    return `${url}?appKey=${appkey}&userId=${user_id}&phone=${phone}&authCode=${authCode}&pkgName=${pkgName}`
  }
}